import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Input,
  InputLabel,
  makeStyles
} from "@material-ui/core";
import { useRef } from "react";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import { Assignment, Check } from "@material-ui/icons";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput";
import MerchantDialog from "components/MerchantDialog/MerchantDialog";
import { travelApi } from "functions/apis";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { formatDateTime } from "functions/Helper";
import ReactTable from "react-table";
import { token } from "functions/Helper";

const useStyles = makeStyles(styles);

export default function MerchantOnlineProductCost() {
  const [filter, setFilter] = React.useState({
    searchString: "",
    merchantID: null,
    currentActive: false
  });
  const [pagination, setPagination] = React.useState({
    pageIndex: 1,
    pageSize: 10
  });
  const [merchantData, setMerchantData] = React.useState({
    id: "",
    name: ""
  });
  const [showModal, setShowModal] = React.useState(false);
  const [data, setData] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const source = useRef(new AbortController());
  const [pages, setPages] = React.useState(0);

  const handleSearchStringChanged = e =>
    setFilter({
      ...filter,
      searchString: e.target.value === "" ? null : e.target.value
    });

  const handleCurrentActiveChanged = e =>
    setFilter({
      ...filter,
      currentActive: e.target.checked
    });

  const handleMerchantIDChanged = e => {
    setMerchantData({ ...merchantData, id: e.id, name: e.name });
    setShowModal(false);
  };

  useEffect(() => {
    if (merchantData.id && merchantData.id != "") {
      setFilter({ ...filter, merchantID: merchantData.id });
    }
  }, [merchantData]);

  useEffect(() => {
    setLoading(true);
    travelApi
      .get("ProductCosts", {
        signal: source.current.signal,
        params: {
          filter,
          pagination
        }
      })
      .then(resp => {
        setData(
          resp.records.map(record => {
            return {
              ...record,
              actions: (
                <div className="actions-right">
                  <>
                    {(token["travelagent.product_costs.write"] === "allowed" ||
                      token.is_admin === "True") && (
                      <Link
                        to={
                          "/admin/MerchantOnlineProductCost/Edit/" + record.id
                        }
                      >
                        <Button
                          color="danger"
                          className="remove"
                          onClick={() => {}}
                        >
                          <EditIcon /> EDIT
                        </Button>
                      </Link>
                    )}
                    {(token["travelagent.product_costs.write"] === "allowed" ||
                      token.is_admin === "True") && (
                      <Link
                        to={
                          "/admin/MerchantOnlineProductCost/Delete/" + record.id
                        }
                      >
                        <Button
                          color="danger"
                          className="remove"
                          onClick={() => {}}
                        >
                          <DeleteIcon /> DELETE
                        </Button>
                      </Link>
                    )}
                  </>
                </div>
              )
            };
          })
        );
        setPages(Math.ceil(resp.totalRecords / pagination.pageSize));
      })
      .catch(err => console.log(err))
      .finally(() => setLoading(false));
  }, [filter, pagination]);

  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              MERCHANT ONLINE PRODUCT COST
            </h4>
          </CardHeader>
          <CardBody>
            {(token["travelagent.product_costs.write"] === "allowed" ||
              token.is_admin === "True") && (
              <Link to={"/admin/MerchantOnlineProductCost/Create"}>
                <Button color="rose" type="button" value="Create">
                  Cerate
                </Button>
              </Link>
            )}

            <GridContainer>
              <GridItem xs={6}>
                <CustomInput
                  labelText="Search"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onchange: handleSearchStringChanged,
                    value: filter.searchString
                  }}
                />
              </GridItem>
              <GridItem xs={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={filter.currentActive}
                      onChange={handleCurrentActiveChanged}
                      checkedIcon={<Check className={classes.checkedIcon} />}
                      icon={<Check className={classes.uncheckedIcon} />}
                      classes={{
                        checked: classes.checked,
                        root: classes.checkRoot
                      }}
                    />
                  }
                  classes={{
                    label: classes.label,
                    root: classes.labelRoot
                  }}
                  label="Current Active"
                />
              </GridItem>
              <GridItem xs={12} sm={12}>
                <FormControl fullWidth className={classes.selectFormControl}>
                  <InputLabel
                    htmlFor="selAgent"
                    className={classes.selectLabel}
                  >
                    Merchant
                  </InputLabel>
                  <Input
                    classes={{
                      input: classes.input,
                      disabled: classes.active,
                      root: classes.active,
                      underline: classes.underline
                    }}
                    value={merchantData.name ?? ""}
                    onClick={() => setShowModal(true)}
                    fullWidth
                  />
                </FormControl>
                <MerchantDialog
                  openModal={showModal}
                  setOpenModal={val => setShowModal(val)}
                  onSelect={handleMerchantIDChanged}
                />
              </GridItem>
            </GridContainer>
            <ReactTable
              manual
              pages={pages}
              page={pagination.pageIndex - 1}
              pageSize={pagination.pageSize}
              onPageChange={page =>
                setPagination({
                  pageIndex: page + 1,
                  pageSize: pagination.pageSize
                })
              }
              onPageSizeChange={(pageSize, page) => {
                setPagination({ pageSize: pageSize, pageIndex: page + 1 });
              }}
              loading={loading}
              data={data}
              filterable={false}
              columns={[
                {
                  id: "code",
                  Header: "Code",
                  accessor: d => d.product.code
                },
                {
                  id: "name",
                  Header: "Name",
                  accessor: d => d.product.name
                },
                {
                  id: "effectiveDate",
                  Header: "Effective Date",
                  accessor: d =>
                    d.effectiveDate
                      ? formatDateTime(new Date(d.effectiveDate))
                      : "-"
                },
                {
                  id: "expiryDate",
                  Header: "Expiry Date",
                  accessor: d =>
                    d.expiryDate ? formatDateTime(new Date(d.expiryDate)) : "-"
                },
                {
                  id: "Variant",
                  Header: "Variant",
                  accessor: d => d.variant.name
                },
                {
                  id: "cost",
                  Header: "Cost",
                  accessor: d => d.cost
                },
                {
                  Header: "Actions",
                  accessor: "actions",
                  sortable: false,
                  filterable: false
                }
              ]}
              defaultPageSize={10}
              showPaginationTop
              showPaginationBottom={false}
              className="-striped -highlight"
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
